export { default } from "./SiteDetailTabs";
